import React, { useState } from "react"
import { FormControlLabel, Switch, SwitchProps } from "@mui/material"


interface CustomSwitchProps extends Omit<SwitchProps, 'defaultValue' | 'onChange'> {
  label?: string
  defaultValue?: boolean
  onChangeCallback?: (value: boolean) => void
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  label = '',
  defaultValue = false,
  onChangeCallback,
  disabled,
  ...switchProps
}) => {
  const [value, setValue] = useState<boolean>(defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setValue(checked)
    onChangeCallback?.(checked)
  }

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          onChange={handleChange}
          disabled={disabled}
          {...switchProps}
        />
      }
      label={label}
    />
  )
}

export default CustomSwitch
